import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import Pillars from "@/components/landing/Pillars";
import Stats from "@/components/landing/Stats";
import WhatWeDo from "@/components/landing/WhatWeDo";
import Gallery from "@/components/landing/Gallery";
import CTASection from "@/components/landing/CTASection";
import FAQ from "@/components/landing/FAQ";
import Footer from "@/components/landing/Footer";
import JoinModalProvider from "@/components/landing/JoinModalProvider";

export default function Home() {
    return (
        <JoinModalProvider>
            <main
                data-testid="landing-page"
                className="min-h-screen bg-[#FAFAFA] text-zinc-950 overflow-x-hidden"
            >
                <Header />
                <Hero />
                <Pillars />
                <Stats />
                <WhatWeDo />
                <Gallery />
                <CTASection />
                <FAQ />
                <Footer />
            </main>
        </JoinModalProvider>
    );
}
